import { convertTimestampToLuxonOrDefaultNow } from "../../utils/convertTimestampToLuxonOrDefaultNow";
export const createRaveRedemptionCode = (data) => {
    assertRaveRedemptionCode(data, "save");
    return data;
};
export function assertRaveRedemptionCodeStatus(status) {
    if (!["dormant", "activated", "redeemed", "deactivated"].includes(status)) {
        throw new Error("RaveRedemptionCodeStatus must be one of: dormant, activated, redeemed, deactivated");
    }
    return status;
}
export function assertRaveRedemptionCodeBase(code) {
    if (!code || typeof code !== "object") {
        throw new Error("RaveRedemptionCode must be an object");
    }
    const c = code;
    // Required fields
    const requiredFields = [
        "code",
        "status",
        "raveId",
        "programId",
        "recipientId",
        "redeemedBy",
        "isFixedValue",
    ];
    for (const field of requiredFields) {
        if (!(field in c)) {
            throw new Error(`RaveRedemptionCode is missing required field: ${field}`);
        }
    }
    // Type checks
    if (typeof c.code !== "string" && c.code !== null)
        throw new Error("RaveRedemptionCode.code must be a string or null");
    if (typeof c.recipientId !== "string" && c.recipientId !== null)
        throw new Error("RaveRedemptionCode.recipientId must be a string or null");
    if (typeof c.redeemedBy !== "string" && c.redeemedBy !== null)
        throw new Error("RaveRedemptionCode.redeemedBy must be a string or null");
    if (typeof c.isFixedValue !== "boolean")
        throw new Error("RaveRedemptionCode.isFixedValue must be a boolean");
    // Validate status
    assertRaveRedemptionCodeStatus(c.status);
    // Validate points based on isFixedValue
    if (c.isFixedValue) {
        if (typeof c.fixedValuePoints !== "number") {
            // Handle legacy/malformed data: if fixedValuePoints is missing but we have points, use that
            if (typeof c.points === "number" && c.points !== null) {
                // Cast to fix the type - this handles legacy data
                c.fixedValuePoints = c.points;
            }
            else {
                throw new Error("RaveRedemptionCode.fixedValuePoints must be a number when isFixedValue is true");
            }
        }
    }
    else {
        if (c.points !== null && typeof c.points !== "number")
            throw new Error("RaveRedemptionCode.points must be null or a number when isFixedValue is false");
    }
    // Validate timestamps
    // if (!(c.createdAt instanceof DateTime))
    //   throw new Error("RaveRedemptionCode.createdAt must be a DateTime");
    // if (c.activatedAt !== null && !(c.activatedAt instanceof DateTime))
    //   throw new Error(
    //     "RaveRedemptionCode.activatedAt must be a DateTime or null",
    //   );
    // if (c.redeemedAt !== null && !(c.redeemedAt instanceof DateTime))
    //   throw new Error("RaveRedemptionCode.redeemedAt must be a DateTime or null");
    // if (!(c.modifiedAt instanceof DateTime))
    //   throw new Error("RaveRedemptionCode.modifiedAt must be a DateTime");
}
export function assertRaveRedemptionCode(code, mode = "load") {
    assertRaveRedemptionCodeBase(code);
    const c = code;
    // Validate status-specific fields
    switch (c.status) {
        case "dormant":
            if (c.recipientId !== null && typeof c.recipientId !== "string")
                throw new Error("RaveRedemptionCode.recipientId must be null in dormant status");
            if (c.redeemedBy !== null)
                throw new Error("RaveRedemptionCode.redeemedBy must be null in dormant status");
            if (c.activatedAt !== null)
                throw new Error("RaveRedemptionCode.activatedAt must be null in dormant status");
            if (c.redeemedAt !== null)
                throw new Error("RaveRedemptionCode.redeemedAt must be null in dormant status");
            break;
        case "activated":
            // Allow redeemedBy to be null or string in activated status
            if (c.redeemedAt !== null)
                throw new Error("RaveRedemptionCode.redeemedAt must be null in activated status");
            break;
        case "redeemed":
            if (typeof c.recipientId !== "string")
                throw new Error("RaveRedemptionCode.recipientId must be a string in redeemed status");
            if (typeof c.redeemedBy !== "string")
                throw new Error("RaveRedemptionCode.redeemedBy must be a string in redeemed status");
        // if (!(c.redeemedAt instanceof DateTime)) TODO: assert either ServerTimestamp or DateTime
        //   throw new Error(
        //     "RaveRedemptionCode.redeemedAt must be a DateTime in redeemed status",
        //   );
        // break;
        case "deactivated":
            // No additional validation needed for deactivated status
            break;
    }
}
export const createRaveRedemptionCodeConverter = (convertToFirestoreTimestampOrDefaultServerTime) => ({
    toFirestore(code) {
        assertRaveRedemptionCode(code, "save");
        const { id, ...codeWithoutId } = code;
        const data = {
            ...codeWithoutId,
            activatedAt: code.activatedAt !== null || codeWithoutId.status === "activated"
                ? convertToFirestoreTimestampOrDefaultServerTime(code.activatedAt)
                : null,
            redeemedAt: code.redeemedAt !== null || codeWithoutId.status === "redeemed"
                ? convertToFirestoreTimestampOrDefaultServerTime(code.redeemedAt)
                : null,
            createdAt: convertToFirestoreTimestampOrDefaultServerTime(code.createdAt),
            modifiedAt: convertToFirestoreTimestampOrDefaultServerTime(code.modifiedAt),
        };
        return data;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        if (!data)
            throw new Error("Snapshot doesn't contain data");
        const code = {
            ...data,
            id: snapshot.id,
            activatedAt: data.activatedAt !== null || data.status === "activated"
                ? convertTimestampToLuxonOrDefaultNow(data.activatedAt)
                : null,
            redeemedAt: data.redeemedAt !== null || data.status === "redeemed"
                ? convertTimestampToLuxonOrDefaultNow(data.redeemedAt)
                : null,
            createdAt: convertTimestampToLuxonOrDefaultNow(data.createdAt),
            modifiedAt: convertTimestampToLuxonOrDefaultNow(data.modifiedAt),
        };
        assertRaveRedemptionCode(code, "load");
        return code;
    },
});
//# sourceMappingURL=RaveRedemptionCode.js.map